import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Card, CardContent, CardMedia, CardActions } from '@material-ui/core'
import { Typography } from './'

const styles = (theme: CentricTheme) => ({
  root:                 {
    width:        224,
    cursor:       'pointer',
    borderRadius: 2
  },
  content:              {
    padding: '0'
  },
  media:                {
    height:         190,
    margin:         `${theme.spacing() * 4}px 0 0`,
    backgroundSize: 'contain'
  },
  cardInfo:             {
    padding:   `${theme.spacing() * 2}px ${theme.spacing() * 2}px 4px`,
    borderTop: `1px solid ${theme.colors.grey5}`
  },
  statusAndTag:         {
    display:        'flex',
    justifyContent: 'space-between',
    padding:        0,
    alignItems:     'center',
    height:         20
  },
  '@keyframes loading': {
    '0%':   {backgroundColor: theme.colors.grey2},
    '20%':  {backgroundColor: theme.colors.grey3},
    '40%':  {backgroundColor: theme.colors.grey4},
    '60%':  {backgroundColor: theme.colors.grey5},
    '85%':  {backgroundColor: theme.colors.grey4},
    '100%': {backgroundColor: theme.colors.grey3}
  },
  loading:              {
    animationDuration:       `1s`,
    animationName:           `loading`,
    animationIterationCount: `infinite`,
    animationTimingFunction: 'ease-out'
  },
  actions:              {
    borderTop:  `1px solid ${theme.colors.grey5}`,
    display:    'flex',
    alignItems: 'center',
    padding:    `0 ${theme.spacing() * 2}px`
  },
  descriptionContainer: {
    marginTop: theme.spacing() * 2
  },
  description:          {
    whiteSpace:   'nowrap',
    overflow:     'hidden',
    textOverflow: 'ellipsis'
  },
  diagonalLine:         {
    width:        405,
    height:       118,
    position:     'absolute',
    borderBottom: '4px solid #f0190a',
    transform:    'translateY(20px) translateX(5px) rotate(123deg)',
    top:          124,
    left:         -47,
    zIndex:       2
  },
  inactive:             {
    opacity: 0.5
  },
  mmcDescription:       {
    fontWeight: 500
  }
})

interface MyProps extends StyledProps {
  /** Image URL for card media */
  image?: string,
  title?: string,
  label?: string,
  raised?: boolean,
  labelcolor?: string,
  description?: string,
  mmc?: string,
  color?: string,
  material?: string,
  loading?: boolean
  onClick?: (e) => void,
  actions?: React.ReactNode,
  active?: boolean
}

@(withStyles as any)(styles)
export class MediaCard extends React.Component<MyProps> {
  static defaultProps = {
    // Use default image url in future
    image:       'no-image',
    active:      true,
    reactivated: false
  }

  render() {
    const {props: {classes, image, title, label, labelcolor, description, raised, loading, onClick, actions, active, mmc, color, material}} = this;

    return (
      <div style={{position: 'relative'}}>
        {!active && <div className={classes.diagonalLine}/>}
        <Card className={classes.root} raised={raised} style={{height: `${actions ? 360 : 320}`}}>
          <CardContent className={`${classes.content} ${!active && classes.inactive}`} onClick={onClick}>
            {loading
             ? <div className={`${classes.media} ${classes.loading}`}/>
             : <CardMedia image={image} title={description} className={classes.media} style={{opacity: active ? 1 : 0.7}}/>}
            <div className={classes.cardInfo} style={{borderColor: `${active ? '#E0E0E0' : '#AEAEAE'}`}}>
              <div className={`${classes.statusAndTag} ${loading ? classes.loading : ''}`}>
                {!loading && <Typography variant='caption'>{title}</Typography>}
                {!loading && label && labelcolor && <Typography variant='caption'
                                                                style={{
                                                                  backgroundColor: labelcolor,
                                                                  padding:         '2px 4px',
                                                                  lineHeight:      1.4,
                                                                  borderRadius:    2,
                                                                  color:           'white'
                                                                }}>
                  {label}
                </Typography>}
              </div>
              <div className={classes.descriptionContainer}>
                <Typography loading={loading} variant='body2' className={`${classes.description} ${classes.mmcDescription}`} title={mmc}>{mmc ? mmc.toUpperCase() : 'NA'}</Typography>
                <Typography loading={loading} variant='body1' className={classes.description} title={material}>{material ? material.toUpperCase() : 'NA'}</Typography>
                <Typography loading={loading} variant='body1' className={classes.description} title={color}>{color ? color.toUpperCase() : 'NA'}</Typography>
              </div>
            </div>
          </CardContent>
          {actions && <CardActions className={classes.actions} style={{borderColor: `${active ? '#E0E0E0' : '#AEAEAE'}`}}>
            {actions}
          </CardActions>
          }
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/MediaCard.tsx